<template>
  <nav-header :title="title"></nav-header>
  <main class="statistics-page is-finn-statistics">
    <div class="container statistics-container statistics-stack">
      <template v-if="apiData != null">
        <section class="statistics-panel">
          <div class="statistics-heading">
            <span class="statistics-heading-icon" aria-hidden="true">
              <i class="material-icons">query_stats</i>
            </span>
            <h2>{{ $englishPreferred ? "My FiNN counts" : "Mine FiNN-tællinger" }}</h2>
          </div>
          <div class="statistics-period-grid">
            <article
              v-for="period in periods"
              :key="period.key"
              class="statistics-period-card"
            >
              <h3>{{ period.label }}</h3>
              <div class="statistics-metric-row">
                <div>
                  <span class="statistics-metric-label">{{ $englishPreferred ? "Amount" : "Antal" }}</span>
                  <strong class="statistics-metric-value">{{ apiData[period.countKey] }}</strong>
                </div>
                <router-link class="statistics-ranking-link" :to="period.rankingTo">
                  {{ $englishPreferred ? "Ranking" : "Rangliste" }}
                  <i class="material-icons" aria-hidden="true">military_tech</i>
                </router-link>
              </div>
            </article>
          </div>
        </section>

        <section class="statistics-panel">
          <div class="statistics-heading">
            <span class="statistics-heading-icon" aria-hidden="true">
              <i class="material-icons">nature</i>
            </span>
            <h2>{{ $englishPreferred ? "Covered FiNN areas" : "Dækkede FiNN-områder" }}</h2>
          </div>
          <div class="statistics-coverage-grid">
            <article
              v-for="period in periods"
              :key="`coverage-${period.key}`"
              class="statistics-coverage-card"
            >
              <i class="material-icons" aria-hidden="true">check_circle</i>
              <div>
                <span class="statistics-coverage-label">{{ period.label }}</span>
                <strong class="statistics-coverage-value">
                  {{ apiData[period.coverageKey] }}
                  <template v-if="totalFinnSites != null"> / {{ totalFinnSites }}</template>
                </strong>
              </div>
            </article>
          </div>
        </section>
      </template>
      <div v-else class="statistics-panel statistics-empty-state">
        {{ $englishPreferred ? "Fetching statistics" : "Henter statistik" }}...
      </div>
    </div>
  </main>
</template>
  
  <script>
  import NavHeader from "@/components/navbars/NavHeader.vue";
  import moment from "moment";
  import axios from "axios";
  import finnSiteRepository from "../idb/repositories/finnSiteRepository";
  
  export default {
    components: {
      NavHeader,
    },
    data() {
      return {
        online: true,
        title: this.$englishPreferred ? "My FiNN statistics" : "Min FiNN-statistik",
        currentYear: new Date().getFullYear(),
        apiData: null,
        totalFinnSites: null,
        moment: moment,
      };
    },
    computed: {
      periods() {
        return [
          {
            key: "total",
            label: this.$englishPreferred ? "All time" : "I alt",
            countKey: "totalCounts",
            coverageKey: "coveredFinnSitesTotal",
            rankingTo: "/finn/statistik/rang/taellinger/total",
          },
          {
            key: "year",
            label: String(this.currentYear),
            countKey: "totalCountsCurrentYear",
            coverageKey: "coveredFinnSitesCurrentYear",
            rankingTo: "/finn/statistik/rang/taellinger/aar",
          },
          {
            key: "recent",
            label: this.$englishPreferred ? "Recent 30 days" : "Seneste 30 dage",
            countKey: "totalCounts30Days",
            coverageKey: "coveredFinnSites30Days",
            rankingTo: "/finn/statistik/rang/taellinger/30",
          },
        ];
      },
    },
    methods: {
      async getIndividualStatistics() {
        return axios.get("/spontan/ranking/statistics/individual/finn");
      },

      async getTotalFinnSites() {
        const finnSites = await finnSiteRepository.getFinnSites();
        this.totalFinnSites = finnSites.length;
      },

      async prepareData() {
        this.getIndividualStatistics()
          .then((response) => {
            this.apiData = response.data;
          })
          .catch(() => {
            console.log("Server did not respond, updating locally");
            this.online = false;
            this.apiData = 0;
          });
      },
    },

    mounted() {
      this.prepareData();
      this.getTotalFinnSites().catch(() => {
        this.totalFinnSites = null;
      });
    },
  };
  </script>

<style scoped>
:deep(#navbar) {
  margin-bottom: 0 !important;
}
</style>
